import { render, staticRenderFns } from "./startErrorTesting.vue?vue&type=template&id=3e9baa25&scoped=true&"
import script from "./startErrorTesting.vue?vue&type=script&lang=js&"
export * from "./startErrorTesting.vue?vue&type=script&lang=js&"
import style0 from "./startErrorTesting.vue?vue&type=style&index=0&id=3e9baa25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9baa25",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
